import { SITE, SITE_URL } from "@/lib/site";
import { LOCATIONS } from "@/data/areas";

const BUSINESS_ID = `${SITE_URL}/#business`;

export const businessLd = () => ({
  "@context": "https://schema.org",
  "@type": "AutomotiveBusiness",
  "@id": BUSINESS_ID,
  name: SITE.name,
  url: `${SITE_URL}/`,
  image: `${SITE_URL}/images/og-image.jpg`,
  logo: `${SITE_URL}/images/logo-tuev-fsp.png`,
  telephone: SITE.phoneIntl,
  email: SITE.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: SITE.street,
    postalCode: SITE.zip,
    addressLocality: SITE.city,
    addressRegion: "NRW",
    addressCountry: "DE",
  },
  geo: { "@type": "GeoCoordinates", latitude: SITE.geo.lat, longitude: SITE.geo.lon },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "00:00",
      closes: "23:59",
    },
  ],
  areaServed: [{ "@type": "City", name: "Köln" }, ...LOCATIONS.map((l) => ({ "@type": l.kind === "koeln" ? "Place" : "City", name: l.label }))],
});

export const locationLd = (loc) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: `Kfz-Gutachten in ${loc.label}`,
  serviceType: "Kfz-Gutachten",
  description: loc.description,
  url: `${SITE_URL}/${loc.slug}`,
  provider: { "@id": BUSINESS_ID },
  areaServed: { "@type": loc.kind === "koeln" ? "Place" : "City", name: loc.label },
});

export const serviceLd = (service) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: service.name,
  serviceType: service.name,
  description: service.description,
  url: `${SITE_URL}/${service.slug}`,
  provider: { "@id": BUSINESS_ID },
  areaServed: { "@type": "City", name: "Köln" },
});

export const faqLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((i) => ({
    "@type": "Question",
    name: i.q,
    acceptedAnswer: { "@type": "Answer", text: i.a },
  })),
});

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [{ label: "Startseite", to: "/" }, ...items].map((item, idx) => ({
    "@type": "ListItem",
    position: idx + 1,
    name: item.label,
    item: `${SITE_URL}${item.to}`,
  })),
});
